import { lazyLoadView } from '@router/helpers';

export default [
  {
    path: '/:operator/:id(\\d+)/kategori',
    name: 'kategori',
    component: () => lazyLoadView(import('@views/admin/kategori/List.vue')),
    meta: {
      title: 'Kategori',
    },
  },
  {
    path: '/:operator/:id(\\d+)/kategori/:item_id(\\d+)',
    name: 'kategori-detil',
    component: () => lazyLoadView(import('@views/admin/kategori/Detail.vue')),
    meta: {
      title: 'Profil Kategori',
    },
  },
];
